import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100",
  style: {"background":"radial-gradient(\n          340px circle at var(--mx) var(--my),\n          rgba(240, 201, 135, 0.14),\n          transparent 60%\n        )"}
}, null, -1)
const _hoisted_2 = { class: "absolute right-6 top-6 font-display text-sm text-copper/30 transition-colors group-hover:text-copper/70" }
const _hoisted_3 = { class: "relative mb-6 flex h-16 w-16 items-center justify-center" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "relative font-display text-xl font-semibold text-ivory transition-colors group-hover:text-copper-light" }
const _hoisted_6 = { class: "relative mt-3 text-sm leading-relaxed text-ivory/50" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 left-0 h-[2px] w-full origin-left scale-x-0 bg-gradient-to-r from-copper via-copper-light to-ember transition-transform duration-500 group-hover:scale-x-100" }, null, -1)

import { computed, reactive, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardComponent',
  props: {
  imageSrc: { type: String, required: true },
  cardTitle: { type: String, required: true },
  text: { type: String, default: "" },
  index: { type: Number, default: 1 },
},
  setup(__props) {

const props = __props;



// eslint-disable-next-line @typescript-eslint/no-var-requires
const icon = computed(() => require(`@/assets/services/${props.imageSrc}`));

const card = ref<HTMLElement | null>(null);
const tilt = reactive({ x: 0, y: 0 });
const spot = reactive({ x: 0, y: 0 });

const onMove = (e: MouseEvent) => {
  if (!card.value) return;
  const rect = card.value.getBoundingClientRect();
  spot.x = e.clientX - rect.left;
  spot.y = e.clientY - rect.top;
  tilt.x = (spot.x / rect.width - 0.5) * 10;
  tilt.y = -(spot.y / rect.height - 0.5) * 10;
};

const reset = () => {
  tilt.x = 0;
  tilt.y = 0;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    ref_key: "card",
    ref: card,
    class: "group relative h-full overflow-hidden rounded-2xl border border-copper/10 bg-gradient-to-b from-smoke to-char p-7 transition-[transform,border-color,box-shadow] duration-300 ease-out hover:border-copper/40 hover:shadow-[0_20px_60px_-20px_rgba(255,122,47,0.45)]",
    style: _normalizeStyle({
      transform: `perspective(900px) rotateX(${tilt.y}deg) rotateY(${tilt.x}deg)`,
      '--mx': `${spot.x}px`,
      '--my': `${spot.y}px`,
    }),
    onMousemove: onMove,
    onMouseleave: reset
  }, [
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, _toDisplayString(String(__props.index).padStart(2, "0")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "metal-icon relative h-14 w-14 transition-transform duration-500 group-hover:scale-110",
        style: _normalizeStyle({ '--icon': `url(${icon.value})` }),
        role: "img",
        "aria-label": __props.cardTitle
      }, null, 12, _hoisted_4)
    ]),
    _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.cardTitle), 1),
    _createElementVNode("p", _hoisted_6, _toDisplayString(__props.text), 1),
    _hoisted_7
  ], 36))
}
}

})